import { render, staticRenderFns } from "./newActivityPage.vue?vue&type=template&id=25c0ec1a"
import script from "./newActivityPage.vue?vue&type=script&lang=js"
export * from "./newActivityPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports